import {gsap} from "gsap";

import {ScrollTrigger} from "gsap/ScrollTrigger";

// Import Swiper e i suoi stili base
import Swiper from 'swiper';
import { Pagination, Manipulation, Navigation, Controller, Autoplay, Thumbs } from 'swiper/modules';

export const ViewProduct = {
    namespace: 'prodotto',
    beforeEnter(data) {

    },
    afterLeave() {



    },
    afterEnter() {

        gsap.to('.block-prodtop .breadcrumb',{
            opacity:1,
            delay:1
        })

        gsap.to('.block-prodtop__t span',{
            y: 0,
            yPercent: 0,
            delay:1
        })


        console.log('prod')

        let $provNavLinks = document.querySelectorAll('.block-prodtab__nav a');
        let $tabWrap = document.querySelector('.block-prodtab__tab-wrap');
        let $tabs = document.querySelectorAll('.block-prodtab__tab');

        $provNavLinks.forEach(el=>{
            el.addEventListener('click',()=>{

                $provNavLinks.forEach(item=>{
                    item.classList.remove('active')
                })

                el.classList.add('active')



                gsap.to('.block-prodtab__tab',{
                    opacity: 0,
                    onStart: () => {

                        gsap.set($tabWrap,{
                            height : () => {
                                return $tabWrap.offsetHeight;
                            }
                        });

                    },
                    onComplete: () => {

                        $tabs.forEach(el=>{
                            el.classList.remove('active')
                        })

                        gsap.to(el.dataset.target,{
                            opacity: 1,
                            onStart: () => {

                                document.querySelector(el.dataset.target).classList.add('active');
                                gsap.set($tabWrap,{
                                    clearPros: 'all'
                                });

                            },
                        })

                    }
                })


            })
        })


        const params = new URLSearchParams(window.location.search);

        if (params.has('v')) {


            const v = params.get('v');  // es: "country-outdoor"
            const selector = `[data-target="#${v}"]`;

            const el = document.querySelector(selector);

            el.click()

        }


        if (document.querySelectorAll('.accordion').length>0) {

            document.querySelectorAll('.accordion').forEach(el=>{

                let groups = gsap.utils.toArray(".accordion-group",el);
                let menus = gsap.utils.toArray(".accordion-menu",el);
                let menuToggles = groups.map(createAnimation);

                menus.forEach(menu => {
                    menu.addEventListener("click", () => toggleMenu(menu));
                });

                if (typeof (el.dataset.firstopen) != 'undefined') {
                    toggleMenu(menus[0]);
                }

                function toggleMenu(clickedMenu) {
                    if (clickedMenu.parentNode.classList.contains('active')) {
                        clickedMenu.parentNode.classList.remove('active');
                    } else {
                        groups.forEach(group => {
                            group.classList.remove('active');
                        });
                        clickedMenu.parentNode.classList.add('active');
                    }
                    menuToggles.forEach(toggleFn => toggleFn(clickedMenu))
                }

                function createAnimation(element) {

                    let menu = element.querySelector(".accordion-menu");
                    let box  = element.querySelector(".accordion-content");

                    gsap.set(box, { height: 0});

                    let animation = gsap.to(box, {
                        height: 'auto',
                        duration: 0.5,
                        ease: "power1.inOut",
                    }).reverse();

                    return function(clickedMenu) {

                        if (clickedMenu === menu) {
                            animation.reversed(!animation.reversed());
                        } else {
                            animation.reverse();
                        }
                    }
                }

            });

        }




        document.querySelectorAll('.block-prodtab__images').forEach(el=>{


            const nav = el.querySelector(".block-prodtab__slider--nav");
            const main = el.querySelector(".block-prodtab__slider--main");

            // NAV (thumbnails)
            const swiperNav = new Swiper(nav, {
                slidesPerView: 3,
                spaceBetween: 16,
                slideToClickedSlide: true,
                watchSlidesProgress: true,
                watchSlidesVisibility: true,
                initialSlide: 1,
            });

            // MAIN (immagine grande)
            const swiperMain = new Swiper(main, {
                slidesPerView: 1,
                modules: [Thumbs,Navigation],
                speed: 500,
                thumbs: {
                    swiper: swiperNav,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            });


        })





    }
}
